<template>
    <ehc-page v-if="userHasPermission(['superAdmin'])">
        <ehc-properties
         headerText="All Properties"
         :showRetrieveAllOption="true">
        </ehc-properties>
    </ehc-page>
</template>


<script>
import ehcProperties from '@/components/properties/ehc-properties.vue'

    export default {
        components: {ehcProperties},
    }

</script>